import styled from "styled-components";

export const OrderStatusWrapper = styled.div`
  width: 100%;
  margin-bottom: 10px;

  .previousDayOrder {
    width: fit-content;
    background-color: #fff;
    padding: 5px 20px;
    border-radius: 8px;
    border: 1px solid #e74c3c;
    animation: zoom-in-zoom-out 1.5s ease;
  }

  .previousDayOrder span {
    color: #e74c3c;
    font-weight: 700;
    font-size: 14px;
  }

  .todayOrder {
    width: fit-content;
    background-color: #fff;
    padding: 5px 20px;
    border-radius: 8px;
    border: 1px solid #f39c12;
    animation: zoom-in-zoom-out 1.5s ease;
  }

  .todayOrder span {
    color: #f39c12;
    font-weight: 700;
    font-size: 14px;
  }

  .hyperlocalOrder {
    width: fit-content;
    background-color: #fff;
    padding: 5px 20px;
    border-radius: 8px;
    border: 1px solid #27ae60;
    animation: zoom-in-zoom-out 1.5s ease;
  }

  .hyperlocalOrder span {
    color: #27ae60;
    font-weight: 700;
    font-size: 14px;
  }

  @keyframes zoom-in-zoom-out {
    0% {
      transform: scale(1, 1);
    }
    25% {
      transform: scale(1.05, 1.05);
    }
    50% {
      transform: scale(1, 1);
    }
    75% {
      transform: scale(1.05, 1.05);
    }
    100% {
      transform: scale(1, 1);
    }
  }
`;

export const OrderDetailsWrapper = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 0.75fr 1fr;
  gap: 1em;
  margin-bottom: 2em;

  .orderIdWrapper {
    grid-column: 1/3;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 1em;

    p {
      font-size: x-large;
    }

    span.danger {
      color: var(--red);
    }
    span.cool {
      color: var(--active);
    }
    span.success {
      color: var(--green);
    }

    .boxSection {
      background: #f2c94c;
      color: var(--dark);
      padding: 0.2em 1em;
      border-radius: 500px;
      font-weight: 600;
      float: right;
      cursor: pointer;
    }
  }

  label {
    font-size: medium;
    color: var(--dark-light);
    font-weight: 400;
    margin: 0;
  }

  p {
    font-weight: 600;
    font-size: medium;
    color: var(--dark);
    margin: 0;
  }
`;
